/** The at-bat ring: solid blue at rest, and these three while a song plays. */
export const AT_BAT_BLUE = '#2563EB'
export const AT_BAT_PURPLE = '#7C3AED'
export const AT_BAT_GREEN = '#22C55E'

/** One clockwise trip of the string around the card. */
export const AT_BAT_SWEEP_MS = 3600

/** How long the ring fades off one batter and onto the next. */
export const AT_BAT_FADE_MS = 280
